const host = "https://test-map.sports.mentech.com/sports";
// const host = "http://172.16.111.221:8097/sports";

// 接口请求统一处理
export function request(config) {
    return new Promise(function(resolve, reject) {
        const ajaxData = {
            type: (config.type || "GET").toUpperCase(),
            url: host + config.url || "",
            async: config.async !== undefined ? config.async : true,
            data: config.data || null,
            params: config.params || null,
            dataType: config.dataType || "json",
            contentType: config.contentType || "application/json; charset=utf-8",
            beforeSend: config.beforeSend || function() {},
            success: config.success || function() {},
            error: config.error || function() {},
        };
        ajaxData.beforeSend();
        const xhr = new XMLHttpRequest();
        xhr.responseType = ajaxData.dataType;

        const params = [];
        for (const key in ajaxData.params) {
            if (typeof ajaxData.params[key] !== "object") {
                params.push(`${key}=${ajaxData.params[key]}`);
            }
        }
        const sendData = params.join("&");

        if (ajaxData.contentType === "multipart/form-data") {
            xhr.open(ajaxData.type, ajaxData.url, ajaxData.async);
        } else {
            xhr.open(ajaxData.type, `${ajaxData.url}?${sendData}`, ajaxData.async);
        }
        // 设置请求头
        const timestamp = new Date().getTime();
        xhr.setRequestHeader("timestamp", timestamp);

        if (ajaxData.type.toUpperCase() === "GET") {
            xhr.send(null);
        } else {
            if (ajaxData.contentType === "multipart/form-data") {
                xhr.send(ajaxData.data.formdata);
            } else {
                xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
                xhr.send(JSON.stringify(ajaxData.data));
            }
        }

        xhr.onreadystatechange = function() {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    if (parseInt(xhr.response.code) === 2000) {
                        request(config); // 递归调用 request 函数
                    } else {
                        ajaxData.success(xhr.response);
                        resolve(xhr.response);
                    }
                } else {
                    ajaxData.error();
                    reject(xhr.response);
                }
            }
        };
    });
}